
import image0 from "gallery-image:test:L1000394-color";
import image1 from "gallery-image:test:L1000398-color";
import image2 from "gallery-image:test:L1000398-bw";
import image3 from "gallery-image:test:L1000402-bw";

const images = { 'L1000394-color': image0,
'L1000398-color': image1,
'L1000398-bw': image2,
'L1000402-bw': image3,
 };
export default {
  ...{"id":"test","title":"urban artworks 2021-11-17"},
  tiles: [ {
  color: "blue",
  size: "small",
  position: "far-left",
  lift: false,
  image: images["L1000394-color"]
}, 
{
  color: "blue",
  size: "small",
  position: "left",
  lift: false,
  image: images["L1000398-color"]
}, 
{
  color: "blue",
  size: "small",
  position: "left",
  lift: false,
  image: images["L1000398-bw"]
}, 
{
  color: "blue",
  size: "small",
  position: "left",
  lift: false,
  image: images["L1000402-bw"]
} ]
};
